import React, { useEffect, useState } from "react";
import { ICreateAndSendPassengers, IFileInfo } from "../../../../../../interface/interfaces";
import { FlexCenter } from "../../../../../layout/FlexCenter/FlexCenter";
import { PanelLayout } from "../../../../../layout/Panel/Panel";
import { Spacing } from "../../../../../layout/Spacing/Spacing";
import { TextCustom } from "../../../../../ui/TextCustom";
import { AiAnalyzerFileButton } from "./AiAnalyzerFileButton";
import { openModal } from "../../../../Modal/modal.slice";
import { fetchKnowladgeGraphDiffPending } from "../KnowladgeGraphDiffTable/knowledgeGraphDiff.slice";
import { clearKnowledgeGraph } from "../KnowladgeGraphDiffTable/knowledgeGraphDiffForSending.slice";
import { addKnowledgeGraphFile } from "../KnowladgeGraphDiffTable/knowledgeGraphSelectedButton.slice";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { ExecButton } from "../../../../../ui/ExecButton/ExecButton";
import { SpacingCustom } from "../../../../../layout/Spacing/SpacingCustom";
import { Button } from "../../../../../ui/Button";
import { rootState } from "../../../../../../redux/store";
import { analyzerPassengerPending, clearAnalayzerPassenger } from "./AyAnalyzerCreateAndSendPassengers.slice";
import { deleteAllBlobs, deleteBlob, getListOfBlobsInContainer } from "../BlobStorage/utils/uploadFileToBlobStorage";
import { BlobItem } from "@azure/storage-blob";

interface IAiAnalyzerShowFileListProps {
    files: IFileInfo[];
}

export const AiAnalyzerShowFileList: React.FC<IAiAnalyzerShowFileListProps>= ({files}) => {

    const [blobItems, setBlobItems] = useState<BlobItem[]>([]);

    const dispatch = useAppDispatch();
    const {project} = useAppSelector((state: rootState) => state.project);

    const getAndShowTableDiff = (fileName: string) => {
        dispatch(clearKnowledgeGraph());
        dispatch(openModal("aiAnalyzerTableModal"));

        dispatch(
            fetchKnowladgeGraphDiffPending({
                url: `${process.env.REACT_APP_KNOWLEDGE_GRAPH_URL_ROOT}/knowledge_graph/differences/?file_url=${process.env.REACT_APP_BLOB_STORAGE_URL}/${process.env.REACT_APP_BLOB_STORAGE_CONTAINER}/${fileName}`,
                token: '',
            }),
        );
        dispatch(addKnowledgeGraphFile(fileName));
    };

    const onCreatePassengers = () => {
        dispatch(clearAnalayzerPassenger());
        const baseUrl = `${process.env.REACT_APP_BLOB_STORAGE_URL}/${process.env.REACT_APP_BLOB_STORAGE_CONTAINER}/`;

        if(files.length > 0){

            const graphIds = files.map((file: IFileInfo) => {
                const fileUrl = `${baseUrl}${file.name}`;
                return fileUrl;
            });

            const dataForCreateAndPassengers: ICreateAndSendPassengers = {
                graph_ids: graphIds,
                project_id: project?._id || "",
            };

            // console.log({url:`${process.env.REACT_APP_PASSENGERS}/create-and-send-passengers`, token:'', body: dataForCreateAndPassengers});

            dispatch(analyzerPassengerPending({url:`${process.env.REACT_APP_PASSENGERS}/create-and-send-passengers`, token:'', body: dataForCreateAndPassengers})); // TODO: add url and token

        }
        
    }

    const getBlobFiles = async ()=>{
        // await deleteBlob('PomeranjeMisa.ahk')
        const blobFiles = await getListOfBlobsInContainer()
        setBlobItems(blobFiles)
    }

    useEffect(()=>{
        getBlobFiles();
    },[])

    return (
        <>
        {/* <div>
            {
                blobItems.map((item: BlobItem, idx: number) =>{
                    return <div key={idx}>{item.name}</div>
                })
            }
        </div> */}
            {files.length > 0 && (
                <>
                <FlexCenter position="start" gap={0.5}>
                    <TextCustom size={1.3} color="dark" weight={600}>
                        Documents
                    </TextCustom>
                    <PanelLayout stretch hasShadow={false} radius="l">
                        <Spacing paddingSpacing="l" marginSpacing="none">
                            <FlexCenter position="start" gap={0.5}>
                                {files.map((file: IFileInfo, idx: number) => {
                                    return (
                                        <AiAnalyzerFileButton key={idx} func={() => getAndShowTableDiff(file.name)} file={file}/>
                                    );
                                })}
                            </FlexCenter>
                        </Spacing>
                    </PanelLayout>
                </FlexCenter>
                <SpacingCustom paddingTop={1}>
                    <FlexCenter position="end" gap={0.5}>
                        {/* <Button label={"Create passengers"} role={"dark"} size={"small"} iconName="Create_passenger" iconSize={1.5} hasIcon/> */}
                        <ExecButton label={"Create data sets"} iconName={"Create_passenger"} size="s" iconSize={1.7} func={()=>onCreatePassengers()}/>  
                    </FlexCenter>
                </SpacingCustom>
            </>
            )}
        </>
    )
}